<template>
  <div class="w-full" v-if="!booking.is_offer">
    <div class="w-full">
      <h2>Detailed Targeting</h2>
    </div>
    <div v-if="$userIsAdmin" class="form-item__row">
      <div class="form-item__field form-item__field--full">
        <div class="input-group">
          <span class="input-group-addon">Targeting Tags</span>
          <div class="form-control" style="height: auto; border: none;">
            <div class="row">
              <div class="col-xs-6">
                <h3>Target</h3>
                <tags type="description" v-model="booking.target_tags"></tags>
              </div>
              <div class="col-xs-6"><h3>Restrict</h3>
                <tags type="description" v-model="booking.restrict_tags"></tags>
              </div>
              <h3 class="col-xs-12">Gender</h3>
              <div class="col-xs-3">
                <div class="radio radio-primary">
                  <input
                    type="radio"
                    name="profile_visibility"
                    id="gender_both"
                    :value="null"
                    v-model="booking.gender">
                  <label for="gender_both">
                    All
                  </label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="radio radio-primary">
                  <input
                    type="radio"
                    name="profile_visibility"
                    id="gender_male"
                    value="male"
                    v-model="booking.gender">
                  <label for="gender_male">
                    Male
                  </label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="radio radio-primary">
                  <input
                    type="radio"
                    name="profile_visibility"
                    id="gender_female"
                    value="female"
                    v-model="booking.gender">
                  <label for="gender_female">
                    Female
                  </label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="radio radio-primary">
                  <input
                    type="radio"
                    name="profile_visibility"
                    id="gender_other"
                    value="other"
                    v-model="booking.gender">
                  <label for="gender_other">
                    Other
                  </label>
                </div>
              </div>
              <div class="col-xs-12">
                <h3># {{ $starLabelPlural | sentenceCase }} Targeted</h3>
                <h3 v-text="talentAvailable"></h3>
                <ladda-button
                  class="btn btn-sm btn-primary pull-right"
                  :click="handleUpdateBookingTagsCallback">
                  Save
                </ladda-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$userIsAdmin && !$vlastMode" class="form-item__row">
      <div class="form-item__field form-item__field--full">
      <div class="input-group">
        <span class="input-group-addon">Description Tags</span>
        <div class="form-control" style="height: auto; border: none;">
          <tags type="description" v-model="booking.description_tags"></tags>
          <ladda-button
            class="btn btn-sm btn-primary pull-right"
            :click="handleUpdateBookingDescriptionTagsCallback">
            Save
          </ladda-button>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { map } from 'lodash'
import { notify } from 'utils'
import { mapActions } from 'vuex'
import Tags from '../misc/Tags'

export default {
  components: { Tags },

  data () {
    return {
      talentAvailable: null,
      genderOptions: [
        {
          id: 'null',
          value: null,
          text: 'None'
        },
        {
          id: 'male',
          text: 'Male'
        },
        {
          id: 'female',
          text: 'Female'
        }
      ]
    }
  },

  props: {
    booking: {
      required: true
    }
  },

  mounted () {
    this.getTalentTally({id: this.booking.id})
      .then(response => {
        this.talentAvailable = response.data
      })
  },

  methods: {
    ...mapActions('booking/request', ['updateBookingRequestDescriptionTags', 'getTalentTally', 'updateBookingRequestTags']),
    handleUpdateBookingDescriptionTagsCallback () {
      return this.updateBookingRequestDescriptionTags({
        id: this.booking.id,
        payload: {tags: map(this.booking.description_tags, 'id')}
      }).then(() => {
        notify.success('Successfully saved description tags')
      }).catch(() => {
        notify.error('Unable to save tags, please try again')
      })
    },

    handleUpdateBookingTagsCallback () {
      return this.updateBookingRequestTags({
        id: this.booking.id,
        payload: {
          target_tags: map(this.booking.target_tags, 'id'),
          restrict_tags: map(this.booking.restrict_tags, 'id'),
          gender: this.booking.gender === 'both' ? null : this.booking.gender
        }
      }).then(() => {
        this.getTalentTally({id: this.booking.id})
          .then(response => {
            this.talentAvailable = response.data
          })
        notify.success('Successfully saved tags')
      }).catch(() => {
        notify.error('Unable to save tags, please try again')
      })
    }
  }
}
</script>
